import { render, staticRenderFns } from "./QuickFormPage.vue?vue&type=template&id=5553a055&scoped=true"
import script from "./QuickFormPage.vue?vue&type=script&lang=js"
export * from "./QuickFormPage.vue?vue&type=script&lang=js"
import style0 from "./QuickFormPage.vue?vue&type=style&index=0&id=5553a055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5553a055",
  null
  
)

export default component.exports